import React, { useRef } from "react";
import emailjs from "emailjs-com";
import MyNav from "../component/nav";
import About from "../component/about";

import Footer from "../component/foot";
function Home() {
  const form = useRef();
  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_y1pql56", // replace this
        "template_5gjphw3", // replace this
        form.current,
        "jdnIlQIUuNLN9grUN" // replace this
      )
      .then(() => {
        alert("✅ Message sent successfully!");
        form.current.reset(); // reset form
      })
      .catch((error) => {
        console.error(error);
        alert("❌ Failed to send message. Please try again.");
      });
  };

  return (
    <>
      <div className="everything app">
        <MyNav />
        <About />
        <div className="about" id="about">
          <h1 className="gang">About Me</h1>
          <div className="Intro-txt">
            Hey there! I'm Prasoon Kandel, a 13-year-old boy studying in Class 9
            from Rupandehi, Nepal. I'm deeply interested in artificial
            intelligence and machine learning. I have a solid foundation in web
            development, and I'm currently focused on mastering Python to build
            cool, intelligent systems. I'm a hands-on learner, always
            experimenting, and I'm excited to contribute to the world of AI!
          </div>
        </div>
        <br />
        <div className="divider"></div>
        <br />
        <section id="github" className="github-section">
          <div className="content">
            <h2>Check Out My GitHub</h2>
            <p>
              I have posted many things on GitHub. Feel free to explore my
              projects!
            </p>
            <a
              href="https://github.com/prasoonkandel"
              target="_blank"
              className="github-link"
              rel="noopener noreferrer">
              Visit My GitHub
            </a>
          </div>
        </section>
        <section className="projects-section" id="projects">
          <div
            className="gang"
            style={{ marginTop: "20px", textAlign: "center" }}>
            My Projects
          </div>

          <div className="projects-container">
            <a
              href="https://todoprk.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              className="project-card card-animate">
              <div className="project-title">To Do App</div>
              <div className="project-link">todoprk.netlify.app</div>
            </a>

            <a
              href="https://contactadderprk.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              className="project-card card-animate">
              <div className="project-title">Contact Adder</div>
              <div className="project-link">contactadderprk.netlify.app</div>
            </a>

            <a
              href="https://prasoon12game.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              className="project-card card-animate">
              <div className="project-title">Head & Tails Game</div>
              <div className="project-link">prasoon12game.netlify.app</div>
            </a>

            <a
              href="https://linksprk.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              className="project-card card-animate">
              <div className="project-title">Useful links</div>
              <div className="project-link">linksprk.netlify.app</div>
            </a>

            <a
              href="https://github.com/prasoonkandel/Wallet_Api"
              target="_blank"
              rel="noopener noreferrer"
              className="project-card card-animate">
              <div className="project-title">Wallet Api</div>
              <div className="project-link">
                github.com/prasoonkandel/Wallet_Api
              </div>
            </a>
          </div>
        </section>
        <div className="divider"></div>

        <section className="skills-section" id="skills">
          <h2 className="gang" style={{ textAlign: "center" }}>
            My Skills
          </h2>
          <br />
          <div className="skills-container">
            <div className="skill-card card-animate">
              <h3>HTML & CSS</h3>
              <p>
                HTML (HyperText Markup Language) is the foundation of web
                development, used for creating the structure and layout of web
                pages. CSS (Cascading Style Sheets) is used to control the look
                and feel of the site, handling design, layout, and
                responsiveness, ensuring web pages look great on all devices.
              </p>
            </div>
            <div className="skill-card card-animate">
              <h3>React.js</h3>
              <p>
                React.js is a powerful JavaScript library for building user
                interfaces, especially for single-page applications. It allows
                for the creation of reusable components and efficient state
                management, making the development of interactive and dynamic
                web applications easier.
              </p>
            </div>
            <div className="skill-card card-animate">
              <h3>Node.js</h3>
              <p>
                Node.js is a runtime environment that allows JavaScript to be
                used for server-side programming. It is built on Chrome’s V8
                JavaScript engine and is ideal for building scalable,
                high-performance network applications, such as web servers and
                APIs.
              </p>
            </div>
            <div className="skill-card card-animate">
              <h3>JavaScript (ES6+)</h3>
              <p>
                JavaScript is a versatile, high-level programming language used
                to create interactive web pages. ES6+ introduces modern features
                such as classes, modules, promises, async/await, and arrow
                functions, making the language more powerful and easier to work
                with.
              </p>
            </div>
            <div className="skill-card card-animate">
              <h3>MongoDB</h3>
              <p>
                MongoDB is a NoSQL database, meaning it stores data in a
                flexible, JSON-like format. It is well-suited for applications
                that require scalable, high-performance databases that can
                handle large amounts of unstructured data, such as web
                applications and data-driven sites.
              </p>
            </div>
          </div>
        </section>

        <section className="contact-section" id="contact">
          <div className="contact-container">
            <div className="gang">Contact Me</div>
            <form ref={form} onSubmit={handleSubmit} className="contact-form">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                className="contact-input"
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                className="contact-input"
                required
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                className="contact-input"
                required
              />
              <textarea
                name="message"
                placeholder="Your Message"
                className="contact-textarea"
                required
                rows="5"></textarea>
              <button type="submit" className="contact-button">
                Send Message
              </button>
            </form>
          </div>
        </section>

        <Footer />
      </div>{" "}
    </>
  );
}

export default Home;
